export default class CopyButton extends React.PureComponent

  constructor: (props) ->
    super(props)

    @state =
      text: @props.initialText

    @onClick = @onClick.bind(this)

  onClick: (e) ->
    @setState(text: @props.successText, ->
      @props.onClick()
      setTimeout(() =>
        @setState(text: @props.initialText)
      , 2000)
    )
  
  render: ->
    iconClasses = if @state.text == @props.initialText then "fas fa-copy" else "fas fa-check"

    <button className="copy-button"
            onClick={@onClick}>
      <i className={iconClasses} />
      {@state.text}
    </button>
